// ====== Zelen Garden APP ===================
var ingredientsFilterJson = '';
var dumbSizeRatio = 1;
var dumbSlickHeight = 1000;

$(document).ready(function(){ 
  
  $("body").bind("DOMSubtreeModified", function() {
      if ($("label:contains('mlveda_country')").parent().css('display') !== 'none') {
          $("label:contains('mlveda_country')").parent().css('display', 'none');
      }
  });

   // Collection sample products add to cart
  if (($('body').hasClass("template-collection"))) {
    // ====== Add to cart ========== 
    $(document).on("click",".addToCartItem",function(){
        showLoaderModel();
        resetAddtocartStorage();
        var variant_id = $(this).attr("data-id");
        if(variant_id){
          action_update_cart(1,variant_id,variant_id);
        }
    });

    $(document).on("click",".close-cart-modal",function(){
          closeCartMessageModal();
    });
    // ====== Add to cart ========== 
  }   
    
  if (($('body').hasClass("template-blog"))&&(window.location.href.indexOf("zelens-garden-ingredients") > -1)) {

    // mobile fade up amination
    enquire.register("screen and (max-width: 767px)", {
        match: function() {
            new WOW({animateClass: 'mobile-effect-active',offset: 0}).init();
        }
    });

    // Add Class for overflow-y hidden for Desktop and Tablet Landscape resolution
    enquire.register("screen and (min-width: 768px) and (orientation: landscape) ", {
        match: function() {
          $('body').removeClass('mobile-app');
          $('body').addClass('desktop-app');
        },
        unmatch: function() { 
          $('body').removeClass('desktop-app');
          $('body').addClass('mobile-app');
        }
    });

    ingredientsFilterJson = ingredientsJson.sort(dynamicSort("title"));

    getIngredients();

    $(window).resize(function() {
         getIngredients();
    });
    
    $('.ingredientSlider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        IngredientProgessBar();
    });
    
    // ====== Search Ingredient ==========
    $(document).on("click",".blog-search",function(){
        $(".blog-search-form").toggleClass('active');
    });

    $(document).on("click",".search-close",function(){
        $(".blog-search-form").removeClass('active');
    });

    $(document).on("click",".m-blog-search",function(){
        $(".ingredient-search-list-model").show();  
    });

    $(document).on("click",".m-search-close",function(){
        $(".ingredient-search-list-model").hide();
    });
  
    $(document).on("keyup","input[name='ingredientsearchkey']",function(){
        var searchkey  = $(this).val();
        if(searchkey){
          setTimeout(function(){ 
            searchIngredientResult(searchkey,'desktop'); 
          }, 500);
        }else{
          if($('.ingredientSlider').hasClass('slick-initialized')){
              $('.ingredientSlider').slick('unslick');
          }
          //getIngredients();

          var tagname = $(".filterbytagbtn.is-active").attr("data-tag");
          if(tagname){
            ingredientsFilterByTag(tagname);
          }

          showZGSearchBarMsg();
        }
    });

    $(document).on("keyup","input[name='ingredientmobilesearchkey']",function(){
        var searchkey  = $(this).val();
        if(searchkey){
          searchIngredientResult(searchkey,'mobile');
        }
    });
    // ====== Search Ingredient ==========

    // ========== Filter By Tag ===============
    $(document).on("click",".filterbytagbtn",function(){
        var tagname = $(this).attr("data-tag");
        $(".filterbytagbtn").removeClass("is-active");
        $(this).addClass("is-active");
        if(tagname){

          // ===== Start Reset Search Bar on both desktop and mobile when we click filter tags====
          // Desktop
          $(".blog-search-form").removeClass('active');
          $("input[name='ingredientsearchkey']").val('');

          // Mobile
          $(".ingredient-search-list-model").hide();
          $(".mobile-search-list").html('');
          $("input[name='ingredientmobilesearchkey']").val('');

          showZGSearchBarMsg();
          // ===== End Reset Search Bar on both desktop and mobile when we click filter tags====

          ingredientsFilterByTag(tagname);

          // ===== window scroll top and start from filter first Item when we click on tags=====
          enquire.register("screen and (max-width: 767px)", {
              match: function() {
                  $(window).scrollTop(0);
              }
          });
        }
    });

    // ====== Details Popup Ingredient ==========
    $(document).on("click",".ingredientsItem",function(){
        $(".ingredient-product-slider").html('');
        $('.ingredientsItem').removeClass("activeModelItem");
        $(this).addClass("activeModelItem");

        $(".ingredient-details-popup .ingredient-detail .product-column-left img").attr("src",$(".ingredientsItem.activeModelItem .ArticleItem__Image").attr("data-src"));
        $(".ingredient-details-popup .ingredient-detail .ingredient-title h1").html($(".ingredientsItem.activeModelItem").attr("data-title")+'<span class="gray-title">'+$(".ingredientsItem.activeModelItem").attr("data-latinname")+'</span>');
        $(".ingredient-details-popup .ingredient-detail .product-column-right .ingredient-description").html($(".ingredientsItem.activeModelItem").attr("data-description"));
        getIngredientProducts($(".ingredientsItem.activeModelItem").attr("data-handle"));

        $(".ingredient-details-popup").show();
    });

    $(document).on("click",".ingredient-modal-close",function(){
        $('.ingredientsItem').removeClass("activeModelItem");
        
        enquire.register("screen and (min-width: 768px)", {
            match: function() {
              if($('.ingredient-product-slider').hasClass('slick-initialized')){
                  $('.ingredient-product-slider').slick('unslick');
              }
            },
            unmatch: function() { }
        });
        $(".ingredient-details-popup").hide();
    });
    // ====== Details Popup Ingredient ========== 

    // ====== Add to cart ========== 
    $(document).on("click",".addToCartItem",function(){
        showLoaderModel();
        resetAddtocartStorage();
        var variant_id = $(this).attr("data-id");
        if(variant_id){
          action_update_cart(1,variant_id,variant_id);
        }
    });

    $(document).on("click",".close-cart-modal",function(){
          closeCartMessageModal();
    });
    // ====== Add to cart ========== 
  }
});

$(document).on('cart.requestComplete', function(event, cart) {
    $("span.Header__CartCount").html(cart.item_count);
});

function showZGSearchBarMsg(message){
  if(message){
      $(".zgsearchbarmsg").html('<span>'+message+'</span>');
  }else{
      $(".zgsearchbarmsg").html('<span>CLICK INGREDIENTS TO DISCOVER MORE</span>');
  }
}

window.addEventListener("orientationchange", function(event) {
  var prev_state = sessionStorage.getItem('orientation_state');
  
  if( window.innerWidth >= window.innerHeight ){
    if (prev_state!='landscape'){
      	sessionStorage.setItem('orientation_state','landscape');
    	location.reload();
    }
  }else{
  	sessionStorage.setItem('orientation_state','portrait');
  }

  
});


function dumbSizes(is_dumb){
  	console.log('dumbSizes: '+is_dumb);
    
    //called after each update
    var ratio = window.devicePixelRatio;
    if (ratio == 0){ ratio = 1; }
    if (ratio > 1){ ratio = 1; }

    var width = $(window).width() * ratio;
    var height = $(window).height() * ratio;

    let header_h = $('.Header__Wrapper').height() + $('.PageHeader').height();
    let slick_h = height - header_h - 30;
    dumbSlickHeight = slick_h;
    var aspect_ratio = slick_h / width;

    console.log('height '+height);
    if((height < 785)&&(width < 1480)){
      console.log('slick_h '+slick_h);

      if(slick_h < 565){
          newRatio = slick_h / 600;
          $('#main').addClass('smallSlideMode');
      }else{
          newRatio = 1;
          $('#main').removeClass('smallSlideMode');
      }

      if(dumbSizeRatio != newRatio){
        //reset and refresh
        dumbSizeRatio = newRatio;
      }

    }else if(aspect_ratio < 0.4){
      dumbSizeRatio = aspect_ratio * 2;
      $('#main').addClass('smallSlideMode');
    }else{
      dumbSizeRatio = 1;
      $('#main').removeClass('smallSlideMode');
    }
    $('.slick-track').height(slick_h);

    if(is_dumb){ 
      //nothing for now 
    }else{ 
      // we need to run getIngredients again but dont get stuck in a loop!
      getIngredients(true);
    }
    dumbImages();
    
}

function dumbImages(){
  $('.ArticleItem__Image').each(function(index){
  	w = $( this ).width();
    h = Math.round(w*1.333); // keep the aspect.
    if (h > (dumbSlickHeight-120)){
    	h = dumbSlickHeight-120;
    }
    
    $( this ).height( h );
  });
}

function dumbHeight(){
  var ratio = window.devicePixelRatio;
  var height = $(window).height() * ratio;
  if(height < 720){
    let header_h = $('.Header__Wrapper').height() + $('.PageHeader').height();
    let slick_h = height - header_h - 30;
  	$('.slick-track').height(slick_h);
  }else{
    $('.slick-track').css('height','auto');
    $('.slick-slider')[0].slick.refresh();
  }
}



function htmlIngList(v,customWidth=''){
  var html = '';
  if(v.title){
    
    if(customWidth){
      //customWidth = customWidth * dumbSizeRatio;
      html += '<div class="Grid__Cell 1/2--tablet 1/3--lap-and-up ingredientsItem '+customWidth+'" data-description="'+v.description+'" data-handle="'+v.handle+'" data-title="'+v.title+'" data-latinname="'+v.latinname+'" style="width:'+customWidth+'px;">';
    }else{
      html += '<div class="Grid__Cell 1/2--tablet 1/3--lap-and-up ingredientsItem" data-description="'+v.description+'" data-handle="'+v.handle+'" data-title="'+v.title+'" data-latinname="'+v.latinname+'">';   
    }
    
    html += '<article class="ArticleItem wow animate__fadeInUp">';
    html += '<a class="ArticleItem__ImageWrapper" href="javascript:;">';
    html += '<span class="plus-icon"></span>';
    html += '<img class="ArticleItem__Image" src="'+v.image+'" alt="'+v.title+'" data-src="'+v.image+'">';
    html += '</a>';
    html += '<div class="ArticleItem__Content">';
    html += '<h2 class="ArticleItem__Title Heading u-h2">';
    html += '<a href="javascript:;">'+v.title+'</a>';
    html += '</h2>';
    html += '<p>'+v.latinname+'</p>';
    html += '</article>';
    html += '</div>';
  }
  return html;
}

function htmlIngMobileList(v){
  var html = '';
  if(v.title){
    html += '<div class="search-item ingredientsItem" data-description="'+v.description+'" data-handle="'+v.handle+'" data-title="'+v.title+'" data-latinname="'+v.latinname+'">';
    html += '<div class="search-pic">';
    html += '<a href="javascript:;"><img class="ArticleItem__Image" src="'+v.image+'" alt="'+v.title+'" data-src="'+v.image+'"></a>';
    html += '</div>';
    html += '<div class="search-info">';
    html += '<h5>'+v.title+'</h5>';
    html += '<p>'+v.latinname+'</p>';
    html += '</div>';
    html += '</div>';
  }
  return html;
}

function getIngredients(is_dumb=false){
    if(ingredientsFilterJson){
      var html = '';

      var customWidth = '';
      var customWidthArr = IngredientSlideWidth();

      $.each(ingredientsFilterJson,function(i,v){

        // landscape and desktop resolution
        enquire.register("screen and (min-width: 992px)", {
            match: function() {
                customWidth = customWidthArr['block90'];
                if (i % 4 == 1) customWidth = customWidthArr['block100'];
                if (i % 4 == 2) customWidth = customWidthArr['block75'];
                if (i % 4 == 3) customWidth = customWidthArr['block90'];
            },
            unmatch: function() {
              customWidth = '';
            }
        });

        html += htmlIngList(v,customWidth);

      });

      if($('.ingredientSlider').hasClass('slick-initialized')){
          $('.ingredientSlider').slick('unslick');
      }

      $(".ingredientSlider").html(html);
      $(".ingredientSlider").attr("data-ingredient-count",ingredientsFilterJson.length);

      // // mobile
      enquire.register("screen and (max-width: 767px)", {
          match: function() {
              if($('.ingredientSlider').hasClass('slick-initialized')){
                  $('.ingredientSlider').slick('unslick');
              }
          }
      });

      // portrait 768 -- 991
      enquire.register("screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) ", {
          match: function() {
              if($('.ingredientSlider').hasClass('slick-initialized')){
                  $('.ingredientSlider').slick('unslick');
              }

              zelensGardeTabletSlider();
              dumbSizes(is_dumb);
              IngredientProgessBar(ingredientsFilterJson.length);
              add_class_scm(ingredientsFilterJson);
          }
      });

      // landscape and desktop resolution
      enquire.register("screen and (min-width: 1025px)", {
          match: function() {
              if($('.ingredientSlider').hasClass('slick-initialized')){
                  $('.ingredientSlider').slick('unslick');
              }
              zelensGardeSlider();
              dumbSizes(is_dumb);
              IngredientProgessBar(ingredientsFilterJson.length);
              add_class_scm(ingredientsFilterJson);
          }
      });

    }
    add_class_lastitem();

}

function ingredientsFilterByTag(searchkey){
    if(searchkey == 'all'){
      getIngredients();
    }else{
        //updated with Threshold and to check a list of product titles (provided by tags)
        const fuse = new Fuse(ingredientsFilterJson, {
          includeScore: true,
          minMatchCharLength : 500,
          keys: ['tags']
        })
        var searchResultsData = fuse.search(searchkey);

        var html = '';
        
        var customWidth = '';
        var customWidthArr = IngredientSlideWidth();

        if(searchResultsData.length > 0){
          $.each(searchResultsData,function(i,v){

            // landscape and desktop resolution
            enquire.register("screen and (min-width: 992px)", {
                match: function() {
                    customWidth = customWidthArr['block90'];
                    if (i % 4 == 1) customWidth = customWidthArr['block100'];
                    if (i % 4 == 2) customWidth = customWidthArr['block75'];
                    if (i % 4 == 3) customWidth = customWidthArr['block90'];
                },
                unmatch: function() {
                  customWidth = '';
                }
            });

            html += htmlIngList(v.item,customWidth);

          });
        }else{
          $.each(ingredientsFilterJson,function(i,v){

            // landscape and desktop resolution
            enquire.register("screen and (min-width: 992px)", {
                match: function() {
                    customWidth = customWidthArr['block90'];
                    if (i % 4 == 1) customWidth = customWidthArr['block100'];
                    if (i % 4 == 2) customWidth = customWidthArr['block75'];
                    if (i % 4 == 3) customWidth = customWidthArr['block90'];
                },
                unmatch: function() {
                  customWidth = '';
                }
            });

            html += htmlIngList(v,customWidth);

          });
        }  
        
        if($('.ingredientSlider').hasClass('slick-initialized')){
            $('.ingredientSlider').slick('unslick');
        }
                
        $(".ingredientSlider").html(html);
        $(".ingredientSlider").attr("data-ingredient-count",searchResultsData.length);

         // mobile
        enquire.register("screen and (max-width: 767px)", {
            match: function() {
                if($('.ingredientSlider').hasClass('slick-initialized')){
                    $('.ingredientSlider').slick('unslick');
                }
            }
        });

        // portrait 768 -- 991
        enquire.register("screen and (min-width: 768px) and (max-width: 1024px)", {
            match: function() {
                if($('.ingredientSlider').hasClass('slick-initialized')){
                    $('.ingredientSlider').slick('unslick');
                }
                zelensGardeTabletSlider();
                //dumbSizes(true);
                IngredientProgessBar(searchResultsData.length);
                add_class_scm(searchResultsData.length);
            }
        });

        // landscape and desktop resolution
        enquire.register("screen and (min-width: 1025px)", {
            match: function() {
                if($('.ingredientSlider').hasClass('slick-initialized')){
                    $('.ingredientSlider').slick('unslick');
                }
                zelensGardeSlider();
                dumbSizes(true);
                IngredientProgessBar(searchResultsData.length);
                add_class_scm(searchResultsData.length);
            }
        });
    }
    add_class_lastitem();  
  
}

function searchIngredientResult(searchkey,screen){
    //updated with Threshold and to check a list of product titles (provided by tags)
    const fuse = new Fuse(ingredientsFilterJson, {
      includeScore: false,
      includeMatches: false,
      shouldSort:true,
      location:5,
      threshold:0.3,
      keys: ['title', 'latinname', 'products.title']
    })
    var searchResultsData = fuse.search(searchkey);

    if(screen == 'desktop'){
      showZGSearchBarMsg(searchResultsData.length+' RESULTS FOUND FOR “'+searchkey+'”');
      var html = '';
      
      var customWidth = '';
      var customWidthArr = IngredientSlideWidth();

      if(searchResultsData.length > 0){
        $.each(searchResultsData,function(i,v){

          // landscape and desktop resolution
          enquire.register("screen and (min-width: 992px)", {
              match: function() {
                  customWidth = customWidthArr['block90'];
                  if (i % 4 == 1) customWidth = customWidthArr['block100'];
                  if (i % 4 == 2) customWidth = customWidthArr['block75'];
                  if (i % 4 == 3) customWidth = customWidthArr['block90'];
              },
              unmatch: function() {
                customWidth = '';
              }
          });

          html += htmlIngList(v.item,customWidth);

        });
      }else{
        $.each(ingredientsFilterJson,function(i,v){

          // landscape and desktop resolution
          enquire.register("screen and (min-width: 992px)", {
              match: function() {
                  customWidth = customWidthArr['block90'];
                  if (i % 4 == 1) customWidth = customWidthArr['block100'];
                  if (i % 4 == 2) customWidth = customWidthArr['block75'];
                  if (i % 4 == 3) customWidth = customWidthArr['block90'];
              },
              unmatch: function() {
                customWidth = '';
              }
          });

          html += htmlIngList(v,customWidth);

        });
      }  
      
      if($('.ingredientSlider').hasClass('slick-initialized')){
          $('.ingredientSlider').slick('unslick');
      }
              
      $(".ingredientSlider").html(html);
      $(".ingredientSlider").attr("data-ingredient-count",searchResultsData.length);

       // mobile
      enquire.register("screen and (max-width: 767px)", {
          match: function() {
              if($('.ingredientSlider').hasClass('slick-initialized')){
                  $('.ingredientSlider').slick('unslick');
              }
          }
      });

      // portrait 768 -- 991
      enquire.register("screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait)", {
          match: function() {
              if($('.ingredientSlider').hasClass('slick-initialized')){
                  $('.ingredientSlider').slick('unslick');
              }
              zelensGardeTabletSlider();
              dumbSizes(true);
              IngredientProgessBar(searchResultsData.length);
              add_class_scm(searchResultsData.length);
          }
      });

      // landscape and desktop resolution
      enquire.register("screen and (min-width: 1025px)", {
          match: function() {
              if($('.ingredientSlider').hasClass('slick-initialized')){
                  $('.ingredientSlider').slick('unslick');
              }
              zelensGardeSlider();
              dumbSizes(true);
              IngredientProgessBar(searchResultsData.length);
              add_class_scm(searchResultsData.length);
          }
      });

    }

    if(screen == 'mobile'){
      var html = '';
       if(searchResultsData.length > 0){
          $.each(searchResultsData,function(i,v){
            html += htmlIngMobileList(v.item);
          });
       }else{
          $.each(ingredientsFilterJson,function(i,v){
            html += htmlIngMobileList(v);
          });
       }
      $(".mobile-search-list").html(html);
    }
  add_class_lastitem();
}

// add class in the last item to move the text if contains 4 items..
function add_class_lastitem() {
  console.log("HERE.....");
  $(".ingredientsItem").removeClass("last-item");
  var numItems = $(".ingredientsItem").length;
  //var ingredientsItem = $(".ingredientsItem").last().attr("data-slick-index");
  //ingredientsItem = ingredientsItem - 1;
  var val = numItems % 2
  if(val == 0 ) {
    $(".ingredientsItem").last().addClass("last-item");
  }
  
  protect_garden_images();
}

function protect_garden_images(){
  //block right clicks and drags on the nice images
  $('.ArticleItem__Image, .product-thumb img').bind("contextmenu",function(e){
    return false;
  });
  $('.product-thumb img').on('mousedown', function(event) { event.preventDefault(); })
}

function add_class_scm(totalRecords){
  if($('.slick-track').length > 0){
    if(totalRecords <= 4 && totalRecords != 0){
      $(".slick-track").addClass("slick-center-mode");
      $(".slick-list").addClass("slick-left-mode-0");
    }else{
      $(".slick-track").removeClass("slick-center-mode");
      $(".slick-list").removeClass("slick-left-mode-0");
    }
  }
}

function getIngredientProducts(handle){
  var ingredient_url = '/pages/custom-ingredient-products-json/'+handle;
  $.get( ingredient_url , function( json_string ) {
    var data = jQuery.parseJSON(json_string);
    var products = data.products;
    if(products){
      var html = '';
      var itemSNO = 1;
      $.each(products,function(i,v){
        if(v.title){

          var title_subtitle = v.title.split(" - ");

          html += '<div class="ingredient-product-item">';
          html += '<div class="ingredient-product-pic">';
          html += '<a href="/products/'+v.handle+'" target="_blank">';
          html += '<img src="'+v.image+'" alt="">';
          html += '</a>';
          html += '</div>';
          html += '<div class="ingredient-product-info">';
          if(title_subtitle[0]){
            html += '<h5>'+title_subtitle[0]+'</h5>';
          }else{
            html += '<h5>'+v.title+'</h5>';  
          }
          
          html += '<div class="ingredient-desc-price">';
          if(title_subtitle[1]){
            html += '<div class="small-desc">'+title_subtitle[1]+'</div>';
          }else{
            html += '<div class="small-desc">'+v.vendor+'</div>';  
          }
          
          html += '<div class="price">'+v.price+'</div>';
          html += '</div>';
          html += '<div class="ingredient-action-count">';
          html += '<div class="ingredient-action">';
          if(v.available == "true"){
              html += '<a href="javascript:;" class="action-link addToCartItem" data-id="'+v.variants[0].id+'" data-name="'+v.title+'">QUICK BUY</a>';
          }else{
              html += '<span class="out-of-stock">OUT OF STOCK</span>';
          }          
          html += '</div>';
          html += '<div class="count">'+itemSNO+'/'+products.length+'</div>';
          html += '</div>';
          html += '</div>';
          html += '</div>';
        }
        itemSNO++;
      });
      $(".ingredient-product-slider").html(html);

      // Desktop and Tablet Landscape resolution  Add Slider
      enquire.register("screen and (min-width: 768px)", {
          match: function() {
              ingredientsProductSlider();
          },
          unmatch: function() {
            if($('.ingredient-product-slider').hasClass('slick-initialized')){
                $('.ingredient-product-slider').slick('unslick');
            }
          }
      });
    }
  });
}

function IngredientSlideWidth(){
    var inslidewidth = [];
    
    var customWidth = '';
    var mainWidth = $(window).width();
    var blockwidth = mainWidth/4;
    var blockA = (blockwidth*90)/100;
    var blockB = (blockwidth*100)/100;
    var blockC = (blockwidth*75)/100;
    var blockD = (blockwidth*90)/100;
    var blockR = (blockwidth*60)/100;
    var blockRW = blockR/4;
  
  
  	if(dumbSizeRatio!=1){
      inslidewidth['mainWidth'] = mainWidth;
      inslidewidth['block90'] = blockA+blockRW;
      inslidewidth['block100'] = blockB+blockRW;
      inslidewidth['block75'] = blockC+blockRW;
      inslidewidth['block90'] = blockD+blockRW;
    }else{
      inslidewidth['mainWidth'] = mainWidth;
      inslidewidth['block90'] = blockA+blockRW;
      inslidewidth['block100'] = blockB+blockRW;
      inslidewidth['block75'] = blockC+blockRW;
      inslidewidth['block90'] = blockD+blockRW;
	}	
  
	/*
      inslidewidth['mainWidth'] = mainWidth;
      inslidewidth['block90'] = blockA+blockRW;
      inslidewidth['block100'] = blockB+blockRW;
      inslidewidth['block75'] = blockC+blockRW;
      inslidewidth['block90'] = blockD+blockRW;
  	*/
    return inslidewidth;
}

function IngredientProgessBar(total = 0){
  if(total == 0){
    var total = $(".ingredientSlider").attr("data-ingredient-count");  
  }
  
  if(total > 4){
    var perPercent = 100/total;
    var currentSlide = $('.slick-current').attr("data-slick-index");
    var activeSlide = parseInt(currentSlide) + parseInt(2);
    var barwidth = perPercent*activeSlide;
    var fullwidth = parseInt(total) - parseInt(3);

    if(activeSlide <= fullwidth){
        $(".slick-progress-item .slick-progress-bar").css("width",barwidth+'%');
    }else{
        $(".slick-progress-item .slick-progress-bar").css("width",'100%');
    }
  }else{
    $(".slick-progress-item .slick-progress-bar").css("width",'100%');
  }
}

function zelensGardeSlider(){
   var slider = $('.ingredientSlider').slick({
    dots: false,
    arrow: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 2,
    variableWidth : true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 991,
        settings: {
          dots: false,
          arrow: true,
          infinite: false,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
    ]
  });
/*
 if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
    slider.on('wheel', (function(e) {
    e.preventDefault();

    if (e.originalEvent.deltaY > 0) {
      $(this).slick('slickNext');
    } else {
      $(this).slick('slickPrev');
    }
  }));
}
*/

//else {
 // https://stackoverflow.com/questions/46508975/how-to-use-mouse-scroll-instead-of-drag-in-slick-js
let blocked = false;
let blockTimeout = null;
let prevDeltaY = 0;

slider.on('mousewheel DOMMouseScroll wheel', (function(e) {
    let deltaY = e.originalEvent.deltaY;
    e.preventDefault();
    e.stopPropagation();

    clearTimeout(blockTimeout);
    blockTimeout = setTimeout(function(){
        blocked = false;
    }, 50);

    
    if (deltaY > 0 && deltaY > prevDeltaY || deltaY < 0 && deltaY < prevDeltaY || !blocked) {
        blocked = true;
        prevDeltaY = deltaY;

        if (deltaY > 0) {
            $(this).slick('slickNext');
        } else {
            $(this).slick('slickPrev');
        }
    }
}));


   /*
    //extra code to rate limit scrolls
    slider.is_animating = false;
    slider.wheel_scroll = function(action){
      if(!slider.is_animating){
        $(this).slick(action);
      }
    };
    
    slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      slider.is_animating = true;
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
      slider.is_animating = false
    });
    //--
    
    //Implementing navigation of slides using mouse scroll 
    //REF: https://medium.com/swlh/implementing-mouse-scroll-in-slick-js-175b5025b79
    slider.on('wheel', (function(e) {
      e.preventDefault();
      if(Math.abs(e.originalEvent.deltaY) > 60){
        if (e.originalEvent.deltaY < 0) {
          //$(this).slick('slickPrev');
          slider.wheel_scroll('slickPrev');
        } else {
          //$(this).slick('slickNext');
          slider.wheel_scroll('slickNext');
        }
      }
    }));
    */
  //}
}


function zelensGardeTabletSlider(){
   $('.ingredientSlider').slick({
    dots: false,
    arrow: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    //variableWidth : true,
  });
}

function ingredientsProductSlider(){
   $('.ingredient-product-slider').slick({
    dots: false,
    arrow: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  });
}

function resetAddtocartStorage(){
  var store = get_store_country();

  if(localStorage.getItem(store+'zelens_addtocart_success')){
      localStorage.removeItem(store+'zelens_addtocart_success');  
  }
  
  if(localStorage.getItem(store+'zelens_addtocart_error')){
    localStorage.removeItem(store+'zelens_addtocart_error');  
  }
}

function dynamicSort(property) {
  var sortOrder = 1;

  if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
  }

  return function (a,b) {
      if(sortOrder == -1){
          return b[property].localeCompare(a[property]);
      }else{
          return a[property].localeCompare(b[property]);
      }        
  }
}

function get_store_country(){
  var host = window.location.host;
  var store = 'uk_';
  if (host.indexOf("eu") != -1) var store = 'eu_';
  else if (host.indexOf("us") != -1) var store = 'us_';
  return store;
}

function action_update_cart(qty,var_id,last_var_id=''){
  if(var_id){
    var store = get_store_country();
    CartJS.addItem(var_id, qty, {},{
        "success": function(data, textStatus, jqxhr) {
            if(localStorage.getItem(store+'zelens_addtocart_success')){
              localStorage.setItem(store+'zelens_addtocart_success', parseInt(localStorage.getItem(store+'zelens_addtocart_success'))+parseInt(1));
            }else{
              localStorage.setItem(store+'zelens_addtocart_success', parseInt(1));
            }
            if(var_id == last_var_id){
              showCartMessageModal();
            }
        },
        "error": function(jqxhr, textStatus, errorThrown) {
            if (jqxhr.responseJSON && jqxhr.responseJSON.status == 422) {
                  var errmsg = jqxhr.responseJSON.description;
            }
            
            var storeErr = localStorage.getItem(store+'zelens_addtocart_error');

            if(storeErr){
                localStorage.setItem(store+'zelens_addtocart_error', storeErr+' | '+errmsg);
            }else{
                localStorage.setItem(store+'zelens_addtocart_error', errmsg);  
            }

            if(var_id == last_var_id){
              showCartMessageModal();
            }
        }
    });
  }
}

function showLoaderModel(){
  $(".modal-add-cart").fadeIn(800);
  $(".modal-cart-info").hide();
  $(".modal-loader").show();
}

function hideLoaderModel(){
  $(".modal-loader").hide();
  $(".modal-cart-info").show();
}

function showCartMessageModal(action,errmsg=''){
    hideLoaderModel();
    var store = get_store_country();

    var addedScount = localStorage.getItem(store+'zelens_addtocart_success');

    if(addedScount == 1){
      $(".modal-cart-info .rfa_success").html('<h4>Product Added to Bag</h4>').show();
    }else if(addedScount > 1){
      $(".modal-cart-info .rfa_success").html('<h4>'+addedScount+' Products Added to Bag</h4>').show();
    }else{
      $(".modal-cart-info .rfa_success").hide();  
    }

    var getErrorsStr = localStorage.getItem(store+'zelens_addtocart_error');
    if(getErrorsStr){
        html = '';
        var getErrorArr = getErrorsStr.split("|");
        if(getErrorArr){
          $.each(getErrorArr,function(i,v){
            html += '<p>'+v+'</p>';
          });
          $(".modal-cart-info .rfa_error").html(html).show();
        }else{
          $(".modal-cart-info .rfa_error").hide();
        }
    }

    //resetAddtocartStorage();
    setTimeout(function(){
        closeCartMessageModal();
    }, 20000);
}

function closeCartMessageModal(){
    $(".modal-cart-info .rfa_success").html('').hide();
    $(".modal-cart-info .rfa_error").html('').hide();
    $(".modal-add-cart").hide();
    $(".modal-cart-info").hide();
    $(".modal-loader").hide();
}

 /* Extra */
    // ------------------------------------------------------------------
function get_all_ingredients_by_ajax_json(){
    var i = 1;
    var loop = false;
    var finalArr = [];
    var timer = setInterval(function() {
        var pageurl = '/pages/all-garden-ingredients-json?page='+i;
        console.log(pageurl);
        $.ajax({url: pageurl}).done(function(data_string) {
            var json_data = JSON.parse(data_string);
            if(json_data.length > 0){
              finalArr.push(json_data);
            }else{
              loop = true;
            }
        });
        i++;
        if(loop){
          clearInterval(timer);
          var myArray = [].concat.apply([], finalArr);   
          localStorage.setItem("devAllJsons", JSON.stringify(myArray));
          console.log(JSON.parse(localStorage.getItem('devAllJsons')));
        } 
    }, 1000);
}
 /* Extra */
    // ------------------------------------------------------------------
